<template>
  <div class="row g-0">
    <div class="col-12 col-md-6 col-lg image" :class="{'contain-image' : containImage}" v-if="image">
      <img :src="require(`@/assets/img/${image}`)" />
    </div>
    <div class="col content-column">
      <div class="modal-icons" v-if="icons">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-12 col-lg-6" v-for="item in icons" :key="item.index">
            <IconItem :item="item" />
          </div>
        </div>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="modal-links navbar navbar-light" v-if="links">
        <ul class="navbar-nav">
          <li class="nav-item" v-for="link in links" :key="link.index">
            <a class="nav-link" :href="link.url" target="_blank" :title="link.title">
              <svg class="bi" fill="currentColor" width="16" height="16">
                <use
                  :xlink:href="require(`bootstrap-icons/bootstrap-icons.svg`) + '#' + link.icon"
                />
              </svg>
              {{ link.title }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import IconItem from "./IconItem";

export default {
  name: "PanelsModalContent",
  components: {
    IconItem,
  },
  props: {
    icons: {
      type: Array,
      required: false
    },
    links: {
      type: Array,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    containImage: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables";

.image {
  min-height: 150px;
  position: relative;
  border-bottom: 1px solid #ddd;

  @media (min-width: 768px) {
    max-width: 500px;
  }

  @media (min-width: map-get($grid-breakpoints,"md")) {
    border-width: 0 1px 0 0;
    border-color: #ddd;
    border-right-style: solid;
  }

  @media (prefers-color-scheme: dark) {
    border-color: $border-color-darkmode;
  }

  img {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    object-fit: cover;
  }

  &.contain-image {
    min-height: 300px;

    img {
      object-fit: contain;
      width: calc(100% - 2rem);
      height: calc(100% - 2rem);
      top: 1rem;
      left: 1rem;
      right: 1rem;
      bottom: 1rem;
    }
  }
}

.modal-icons {
  font-size: 0.9rem;
  border-bottom: 1px solid #ddd;

  padding: 0.5rem 1rem;

  @media (prefers-color-scheme: dark) {
    border-color: $border-color-darkmode;
  }
}

.modal-links {
  font-size: 0.9rem;
  border-top: 1px solid #ddd;

  padding: 0 1rem;

  @media (prefers-color-scheme: dark) {
    border-color: $border-color-darkmode;
  }

  svg {
    margin-top: -3px;
    margin-right: 0.25rem;
  }
}

.content-column {
  display: flex;
  flex-direction: column;

  > .content {
    padding: 1rem;
    flex-grow: 1;
  }

}
</style>
